import { render, staticRenderFns } from "./EmployeesNew.vue?vue&type=template&id=bbd60bc8&scoped=true&"
import script from "./EmployeesNew.vue?vue&type=script&lang=js&"
export * from "./EmployeesNew.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./EmployeesNew.vue?vue&type=style&index=1&id=bbd60bc8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd60bc8",
  null
  
)

component.options.__file = "EmployeesNew.vue"
export default component.exports